// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.C_sCx0 {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  background: var(--surface-neutral-white);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);
  border-radius: var(--radius-s);
  overflow: hidden;
  position: relative;
  min-height: 0;
}

.M3SS_M {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 24px;
  padding: 24px;
  width: 100%;
  flex: 1;
  height: 100%;
}

.xgB9Ku {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  gap: 24px;
  padding: 24px 0px;
}

.SrAblC {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 72px;
  height: 72px;
}

.ikN6nh {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 72px;
  height: 72px;
  background: #eaffe5;
  border-radius: 100px;
  color: #387c2b;
}

.OtAZJT {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.Yyaiv0 {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 1.2;
  text-align: center;
  color: #1f1f1f;
  margin: 0;
}

.tHzCbL {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.2;
  text-align: center;
  color: #1f1f1f;
  margin: 0;
}

.Xn4K_N {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  flex: 1;
}

.KoZzBu {
  height: 1px;
  background: #e6e6e6;
  align-self: stretch;
}

.yBq889 {
  display: flex;
  flex-direction: row;
  align-self: stretch;
  gap: 24px;
  width: 100%;
}

.MgLxqC {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.FS32MD {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.FLgXID {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.8;
  color: #1f1f1f;
  height: 21px;
}

.fE7L2T {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.8;
  color: #1f1f1f;
}

.XTVuEm {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 8px;
}

.R5aGQP {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.8;
  color: #1f1f1f;
}

.IsngTz {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  align-self: stretch;
  gap: 12px;
  padding: 24px;
  background: #ffffff;
  width: 100%;
}

.nf05ip {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: transparent;
  border: 2px solid #d64000;
  border-radius: 4px;
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.424;
  color: #d64000;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.nf05ip:hover {
  background: #d64000;
  color: #ffffff;
}

.nf05ip:focus {
  outline: 2px solid #d64000;
  outline-offset: 2px;
}

.POvKJD {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  background: #d64000;
  border: none;
  border-radius: 4px;
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.424;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.POvKJD:hover {
  background: #b23a00;
}

.POvKJD:focus {
  outline: 2px solid #d64000;
  outline-offset: 2px;
}

/* Responsividade para mobile */
@media (max-width: 768px) {
  .IC9H17 {
    padding: 16px;
  }

  .M3SS_M {
    padding: 16px;
  }

  .yBq889 {
    flex-direction: column;
    gap: 16px;
  }

  .IsngTz {
    flex-direction: column;
    gap: 8px;
    padding: 16px;
  }

  .nf05ip,
  .POvKJD {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/PixTransferSuccess/PixTransferSuccess.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,wCAAwC;EACxC,2CAA2C;EAC3C,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,WAAW;EACX,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,OAAO;AACT;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,aAAa;EACf;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".main {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  background: var(--surface-neutral-white);\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);\n  border-radius: var(--radius-s);\n  overflow: hidden;\n  position: relative;\n  min-height: 0;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 24px;\n  padding: 24px;\n  width: 100%;\n  flex: 1;\n  height: 100%;\n}\n\n.header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  align-self: stretch;\n  gap: 24px;\n  padding: 24px 0px;\n}\n\n.successIcon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 72px;\n  height: 72px;\n}\n\n.successIconBackground {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 72px;\n  height: 72px;\n  background: #eaffe5;\n  border-radius: 100px;\n  color: #387c2b;\n}\n\n.messages {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.title {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 1.2;\n  text-align: center;\n  color: #1f1f1f;\n  margin: 0;\n}\n\n.subtitle {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.2;\n  text-align: center;\n  color: #1f1f1f;\n  margin: 0;\n}\n\n.details {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 100%;\n  flex: 1;\n}\n\n.divider {\n  height: 1px;\n  background: #e6e6e6;\n  align-self: stretch;\n}\n\n.transactionInfo {\n  display: flex;\n  flex-direction: row;\n  align-self: stretch;\n  gap: 24px;\n  width: 100%;\n}\n\n.infoRow {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n}\n\n.infoGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.label {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.8;\n  color: #1f1f1f;\n  height: 21px;\n}\n\n.value {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.8;\n  color: #1f1f1f;\n}\n\n.participantInfo {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  gap: 8px;\n}\n\n.participantValue {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.8;\n  color: #1f1f1f;\n}\n\n.actions {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  align-self: stretch;\n  gap: 12px;\n  padding: 24px;\n  background: #ffffff;\n  width: 100%;\n}\n\n.secondaryButton {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: transparent;\n  border: 2px solid #d64000;\n  border-radius: 4px;\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.424;\n  color: #d64000;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n}\n\n.secondaryButton:hover {\n  background: #d64000;\n  color: #ffffff;\n}\n\n.secondaryButton:focus {\n  outline: 2px solid #d64000;\n  outline-offset: 2px;\n}\n\n.primaryButton {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  background: #d64000;\n  border: none;\n  border-radius: 4px;\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.424;\n  color: #ffffff;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n}\n\n.primaryButton:hover {\n  background: #b23a00;\n}\n\n.primaryButton:focus {\n  outline: 2px solid #d64000;\n  outline-offset: 2px;\n}\n\n/* Responsividade para mobile */\n@media (max-width: 768px) {\n  .container {\n    padding: 16px;\n  }\n\n  .content {\n    padding: 16px;\n  }\n\n  .transactionInfo {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .actions {\n    flex-direction: column;\n    gap: 8px;\n    padding: 16px;\n  }\n\n  .secondaryButton,\n  .primaryButton {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `C_sCx0`,
	"content": `M3SS_M`,
	"header": `xgB9Ku`,
	"successIcon": `SrAblC`,
	"successIconBackground": `ikN6nh`,
	"messages": `OtAZJT`,
	"title": `Yyaiv0`,
	"subtitle": `tHzCbL`,
	"details": `Xn4K_N`,
	"divider": `KoZzBu`,
	"transactionInfo": `yBq889`,
	"infoRow": `MgLxqC`,
	"infoGroup": `FS32MD`,
	"label": `FLgXID`,
	"value": `fE7L2T`,
	"participantInfo": `XTVuEm`,
	"participantValue": `R5aGQP`,
	"actions": `IsngTz`,
	"secondaryButton": `nf05ip`,
	"primaryButton": `POvKJD`,
	"container": `IC9H17`
};
module.exports = ___CSS_LOADER_EXPORT___;
